import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'de_CH',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '47895dab-4b11-4863-a3ce-668d7c32364d',
  ''
);
